module.exports = __webpack_public_path__ + "static/media/shimakaze-lose.2527c03b.png";